const relatorio_escolas_sem_continuidade = {
  path: "/relatorio-escolas-sem-continuidade",
  redirect: "/relatorio-escolas-sem-continuidade",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Tabelas de Apoio Planejamento",
  },
  children: [
    {
      path: "/relatorio-escolas-sem-continuidade",
      name: "relatorio-escolas-sem-continuidade",
      component: () =>
        import(
          "@/views/RelatorioEscolasSemContinuidadeEnsino/RelatorioEscolasSemContinuidadeEnsino.vue"
        ),
    },
  ],
};

export { relatorio_escolas_sem_continuidade };
